import styled from "styled-components";

interface IOTPInputProps {
    error: boolean
}

export const OTPInput = styled.input`
  width: 50px;
  height: 50px;
  text-align: center;
  caret-color: #444444;
  border: none;
  border-radius: 4px;
  outline: 1px solid ${({error}: IOTPInputProps) => error ? '#FF0000' : 'rgba(0, 0, 0, 0.6)'};
  font-size: 2rem;
  transition: border 0.2s, box-shadow 0.2s;

  &:nth-child(3) {
    margin-right: 20px;
  }

  &:hover {
    outline-color: ${({error}: IOTPInputProps) => error ? '#FF0000' : 'rgba(0, 0, 0, 0.87)'};
  }

  &:focus {
    outline-width: 2px;
    outline-color: #3f51b5;
  }
`;

export const OTPFormContainer = styled.div`
  margin: 20px 0;
  display: flex;
  gap: 10px;
`;
